import React, { forwardRef } from 'react'
import { Pagination, PaginationProps } from '@mui/material'

import { colorTokens } from '@/apps/latest/shared/styles/colorTokens'
import { RADIUS } from '@/shared/styles/radii'

// Notion 流 pagination.
// active = bg.subtle + fg.default (= 青を使わず中立).
// hover = overlay.hover.

export const NotionPagination = forwardRef<
  HTMLDivElement,
  Omit<PaginationProps, 'color'>
>((props, ref) => (
  <Pagination
    ref={ref}
    shape="rounded"
    size="small"
    {...props}
    sx={[
      {
        '& .MuiPaginationItem-root': {
          fontSize: 13,
          color: colorTokens.fg.default,
          borderRadius: `${RADIUS.md}px`,
          '&.Mui-selected': {
            backgroundColor: colorTokens.overlay.selected,
            color: colorTokens.fg.default,
            fontWeight: 600,
            '&:hover': {
              backgroundColor: colorTokens.overlay.active,
            },
          },
          '&:hover': {
            backgroundColor: colorTokens.overlay.hover,
          },
        },
      },
      ...(Array.isArray(props.sx) ? props.sx : props.sx ? [props.sx] : []),
    ]}
  />
))
NotionPagination.displayName = 'NotionPagination'
